import React from "react";

interface PrescriptionApprovalHeaderProps {
  isDarkMode: boolean;
  pendingCount: number;
  urgentCount: number;
}

export function PrescriptionApprovalHeader({
  isDarkMode,
  pendingCount,
  urgentCount,
}: PrescriptionApprovalHeaderProps) {
  return null;
}
